import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="relative w-10 h-10 rounded-md bg-primary-500 flex items-center justify-center overflow-hidden">
                <i className="ri-train-fill text-foreground-950 text-xl" />
                <span className="absolute inset-x-0 bottom-0 h-[3px] bg-accent-500" />
              </span>
              <span className="font-heading text-xl font-semibold text-foreground-950">痴汉电车</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 max-w-md">
              专注「痴汉电车」题材影视作品的剧情档案站。以整理、考据与推荐为核心，帮助影迷快速了解作品脉络，找到值得花两小时的那一部。
            </p>
            <p className="mt-5 text-xs text-foreground-500 max-w-md leading-relaxed">
              本站所有作品名称、人物、剧情均为示范用途的虚构内容，与任何真实影片、机构或个人无关。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm tracking-[0.2em] text-foreground-800">浏览</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/category/movie" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  电视剧分类
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  剧情专题
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm tracking-[0.2em] text-foreground-800">关于</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  网站介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  使用须知
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  版权声明
                </Link>
              </li>
              <li>
                <a href="mailto:archive@chikandensha-demo.com" className="text-foreground-600 hover:text-primary-400 transition-colors">
                  内容反馈
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 痴汉电车 · 影视剧情档案 ｜ 本站为非商业性演示站点</p>
          <p className="text-xs text-foreground-500">内容仅供观影参考，请支持正版发行渠道</p>
        </div>
      </div>
    </footer>
  );
}